import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { IUserState } from '../models';
import { $api, globalConst } from '..';

export function useUserData() {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...arg } = useQuery<{ user: IUserState }>({
    queryKey: [globalConst.queryKeys.USER_DATA],
    queryFn: async () => {
      const { data } = await $api.get('/mypage', {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return { user: data || [] };
    },
    refetchOnMount: true,
    enabled: isAuthenticated
  });

  return { ...data, ...arg };
}
